var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearBell24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50285 13.5247L3.20019 15.6254C3.05164 16.6564 2.97737 17.1719 3.14799 17.5255C3.29714 17.8345 3.56365 18.0712 3.8882 18.1826C4.25948 18.3102 4.76257 18.1754 5.76873 17.9058L18.7844 14.4183C19.7905 14.1487 20.2937 14.0139 20.5514 13.7178C20.7768 13.4589 20.8892 13.1208 20.8638 12.7785C20.8349 12.3871 20.5128 11.9777 19.8686 11.1591L18.5562 9.49121C18.4146 9.31121 18.3437 9.22121 18.2775 9.12898C17.9604 8.68712 17.7153 8.19769 17.5514 7.67902C17.5173 7.57079 17.4877 7.46016 17.4283 7.23891C16.2082 2.68526 12.423 0.149962 8.28339 1.25919C4.1437 2.36841 2.13328 6.45662 3.35342 11.0102C3.41271 11.2315 3.44236 11.3421 3.46687 11.4529C3.58433 11.984 3.6168 12.5305 3.56306 13.0717C3.55184 13.1846 3.53552 13.298 3.50285 13.5247ZM7.97448 19.9769L14.598 18.2022C14.598 18.2022 14.6575 21.7358 11.7597 22.5122C8.86188 23.2886 7.97448 19.9769 7.97448 19.9769Z",
    fill: "url(#paint0_linear_1_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33287 8.95608L7.62267 3.05524L3.61863 5.08017L3.55522 6.99702L1.92554 7.84286L2.54749 9.98569L2.06949 13.4526L4.44881 12.0776L6.20106 12.5604L7.35586 9.68416L9.33287 8.95608Z",
    fill: "url(#paint1_linear_1_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.266 0.328804L7.86694 4.47332L11.4967 8.1909L13.2116 7.53753L14.708 9.04243L16.3051 7.53637L19.5745 6.76143L17.2665 4.61722L16.8819 2.47301L13.8193 2.26705L12.266 0.328804Z",
    fill: "url(#paint2_linear_1_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5375 1.37337C14.5952 0.548644 13.6981 -0.0877361 12.7994 0.140418L10.05 0.838404C9.51348 0.974618 9.13522 1.39106 9.10079 1.88344L8.96747 3.78991C8.93304 4.28229 9.24967 4.74732 9.76203 4.95688L12.3875 6.03071C13.2457 6.38172 14.2227 5.87639 14.2803 5.05166L14.5375 1.37337Z",
    fill: "url(#paint3_linear_1_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4671 8.08359C3.95305 8.75244 5.04935 8.66326 5.59114 7.91081L7.24861 5.60887C7.57207 5.15965 7.59415 4.59749 7.30403 4.19818L6.1807 2.65204C5.89058 2.25272 5.34912 2.10001 4.82192 2.26882L2.12046 3.13383C1.23742 3.41658 0.813829 4.43168 1.29978 5.10052L3.4671 8.08359Z",
    fill: "url(#paint4_linear_1_393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59832 2.47402C5.41806 1.8454 5.85164 1.16957 6.56674 0.964517L7.86154 0.593238C8.57664 0.388187 9.30247 0.73156 9.48273 1.36018L10.1355 3.63663C10.3157 4.26526 9.88217 4.94108 9.16706 5.14614L7.87226 5.51742C7.15716 5.72247 6.43133 5.37909 6.25108 4.75047L5.59832 2.47402Z",
    fill: "url(#paint5_linear_1_393)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_393",
    x1: 3,
    y1: 0.999947,
    x2: 24.2411,
    y2: 18.5459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_393",
    x1: 10.8376,
    y1: 4.49744,
    x2: -1.72435,
    y2: 7.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F8C3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_393",
    x1: 7.65034,
    y1: 0.328877,
    x2: 17.5047,
    y2: 12.0721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F8C3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_393",
    x1: 9.24541,
    y1: -0.18475,
    x2: 14.8737,
    y2: 5.57306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_393",
    x1: 0.603153,
    y1: 4.1417,
    x2: 8.61576,
    y2: 4.93462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_393",
    x1: 5.27193,
    y1: 1.3358,
    x2: 10.868,
    y2: 3.88251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearBell24);
export default __webpack_public_path__ + "static/media/newyear-bell_24.1a9f8ff5.svg";
export { ForwardRef as ReactComponent };